var map = {
	"./40k-desktop.jpeg": 1496,
	"./40k-desktop.webp": 7607,
	"./40k-mobile.jpeg": 2466,
	"./blood-bowl-desktop.jpeg": 9060,
	"./blood-bowl-mobile.jpeg": 8906,
	"./desktop/image-curiosity.jpg": 8703,
	"./desktop/image-deep-earth.jpg": 4888,
	"./desktop/image-fisheye.jpg": 1248,
	"./desktop/image-from-above.jpg": 217,
	"./desktop/image-grid.jpg": 8324,
	"./desktop/image-hero.jpg": 8002,
	"./desktop/image-interactive.jpg": 4967,
	"./desktop/image-night-arcade.jpg": 4660,
	"./desktop/image-pocket-borealis.jpg": 5751,
	"./desktop/image-soccer-team.jpg": 6072,
	"./favicon-32x32.png": 6036,
	"./fill-1.png": 9298,
	"./fill-2.png": 9951,
	"./fill-3.png": 640,
	"./fill-4.png": 7161,
	"./icon-close.svg": 4909,
	"./icon-facebook.svg": 4802,
	"./icon-hamburger.svg": 5543,
	"./icon-instagram.svg": 3856,
	"./icon-pinterest.svg": 3197,
	"./icon-twitter.svg": 6236,
	"./images": 2088,
	"./images.js": 2088,
	"./logo.svg": 1937,
	"./loopstudios.png": 5332,
	"./magic-desktop.jpg": 5926,
	"./magic-mobile.jpg": 8352,
	"./malditosdice.png": 577,
	"./mobile/image-curiosity.jpg": 6893,
	"./mobile/image-deep-earth.jpg": 4704,
	"./mobile/image-fisheye.jpg": 8145,
	"./mobile/image-from-above.jpg": 9065,
	"./mobile/image-grid.jpg": 7068,
	"./mobile/image-hero.jpg": 3435,
	"./mobile/image-interactive.jpg": 8123,
	"./mobile/image-night-arcade.jpg": 60,
	"./mobile/image-pocket-borealis.jpg": 8367,
	"./mobile/image-soccer-team.jpg": 509,
	"./pngs/few-dice.png": 3622,
	"./pngs/gigant-dice.png": 5525,
	"./pngs/guy rolling dice blue.png": 7544,
	"./pngs/man&girl-boardgame.png": 2091,
	"./pngs/man&girl-dice.png": 6946,
	"./pngs/many-dice.png": 2178,
	"./pngs/robot.png": 7951,
	"./pngs/stupid-one.png": 9745,
	"./pngs/two gods playing.png": 6373,
	"./stratego-desktop.png": 4732,
	"./stratego-mobile.png": 2817
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6303;